import React from 'react';
import { useTranslation } from 'react-i18next';

const DetailHeroSection = () => {
  const { t } = useTranslation('latvia');

  return (
    <section className="relative pt-16 pb-5 md:pt-32 md:pb-20 bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white">
      <div className="absolute inset-0 opacity-20">
        <img
          src="https://public.readdy.ai/ai/img_res/a5dbc3d9919983e6e098746b902f564a.jpg"
          alt="Định cư Latvia - Thành phố Riga cổ kính"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 to-black/80"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <span className="inline-block px-2.5 py-0.5 md:hidden bg-gold-600/20 border border-gold-500/30 rounded-full text-[9px] text-gold-300 font-medium mb-1.5">
          <i className="ri-global-line mr-0.5 text-[9px]"></i>{t('detail.hero.badge')}
        </span>
        <h2 className="text-lg leading-snug md:text-5xl lg:text-6xl font-bold mb-1 md:mb-6 font-serif">
          <strong>{t('detail.hero.title')}</strong> {t('detail.hero.titleSub')}
        </h2>
        <p className="text-[11px] leading-relaxed md:text-xl text-gray-300 max-w-3xl">
          {t('detail.hero.description')}
        </p>
      </div>
    </section>
  );
};

export default DetailHeroSection;